import type { Places } from '~/types/places';

const PLACES_PROFILE: Places = {
  business: {
    bank: -15,
    government: -10,
    office: -15,
  },
  education: {
    childcare: 0,
    high_school: 0,
    library: -5,
    primary: 0,
    university: 0,
  },
  essentials: {
    electricity: 10,
    gas: 5,
    sewers: 5,
    waste: 5,
    water: 10,
  },
  food: {
    bakery: 10,
    coffee: 10,
    fast_food: 15,
    restaurant: 15,
  },
  health: {
    clinic: 5,
    dentist: 0,
    hospital: -5,
    pharmacy: 5,
  },
  nature: {
    beach: 15,
    forest: 10,
    lake: 15,
    mountain: 10,
    park: 12,
    river: 15,
  },
  religion: {
    church: 0,
    mosque: 0,
  },
  shops: {
    grocery: 10,
    mall: 15,
  },
  soil: {
    clay: 10,
    loam: 15,
    peat: 10,
    salt: -5,
    sand: 15,
    silt: 10,
  },
  sport: {
    gym: -5,
    pool: 10,
  },
  telecom: {
    cable_tv: 5,
    fiber_optic: 5,
    network_4g: 15,
    network_5g: 10,
    phone: 15,
  },
  transport: {
    airport: 10,
    bus: 10,
    ferry: 15,
    gas_station: 10,
    metro: 5,
    parking: 12,
    taxi: 15,
    train: 10,
    tram: 7,
  },
};

export default PLACES_PROFILE;
